import React from 'react';
import styled from 'styled-components';
import { colors, fonts } from '../GlobalStyle';
import { calc4k } from '../utilities';
import iconSVG from '../data/images/map.svg';

export default function CardSlider({ data, currStep, offset, title, height }) {
    return (
        <Container
            height={height}
            offset={offset ? 1 : 0}
            style={{
                position: 'relative',
                transition: 'transform 600ms ease-in-out',
                transform: `translate(-${calc4k(
                    690 * (currStep < 6 ? currStep : 5)
                )})`
            }}>
            {title ? <Title>{title}</Title> : null}
            <Content>
                {data.map((d, idx) => {
                    return (
                        <Card key={idx}>
                            <ImageContainer>
                                <Image src={d.img} />
                                <Time>
                                    <span>{d.displayTime}</span>
                                    {d.displayTimePeriod}
                                </Time>
                            </ImageContainer>
                            <EventType>{d.type}</EventType>
                            <EventTitle>{d.title}</EventTitle>
                            {
                                d.location ? (
                                    <EventLocation>
                                        <Icon src={iconSVG} />
                                        {d.location}
                                    </EventLocation>
                                ) : null
                            }                            
                        </Card>
                    );
                })}
            </Content>
        </Container>
    );
}

const Container = styled.div`
    // display: flex;
    position: absolute;
    top: ${p => (p.offset ? calc4k(-115) : 0)};
    height: ${p => (p.height ? p.height : calc4k(956))};
    padding-left: ${calc4k(90)};
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    padding-bottom: ${calc4k(96)};
`;

const Content = styled.div`
    //height: 100%;
    display: flex;
    position: relative;
`;

const Card = styled.div`
    position: relative;
    max-width: ${calc4k(600)};
    display: flex;
    flex-direction: column;
    margin-right: ${calc4k(90)};
`;

const EventType = styled.div`
    text-transform: uppercase;
    color: #afafaf;
    margin-top: ${calc4k(22)};
    font-size: ${calc4k(36)};
    font-weight: 500;
    font-family: ${fonts.headline};
    letter-spacing: ${calc4k(1)};
    line-height: ${calc4k(87)};
`;
const EventTitle = styled.div`
    font-size: ${calc4k(60)};
    font-weight: 500;
    font-family: ${fonts.headline};
    letter-spacing: ${calc4k(1)};
    line-height: ${calc4k(78)};
    margin-bottom: ${calc4k(27)};
`;
const EventLocation = styled.div`
    color: #ffffff;
    font-family: ${fonts.body};
    font-size: ${calc4k(40)};
    line-height: ${calc4k(42)};
`;

const Icon = styled.img`
    height: ${calc4k(40)};
    width: auto;
    margin-right: ${calc4k(19)};
`;

const Title = styled.div`
    color: white;
    font-size: ${calc4k(50)};
    font-weight: 500;
    text-transform: uppercase;
    margin-bottom: ${calc4k(96)};
    padding-top: ${calc4k(96)};
`;

const ImageContainer = styled.div`
    position: relative;
    height: ${calc4k(500)};
`;

const Image = styled.img`
    height: ${calc4k(500)};
    width: ${calc4k(600)};
`;

const Time = styled.div`
    background-color: black;
    position: absolute;
    bottom: -${calc4k(3)};
    color: #ffffff;
    font-family: ${fonts.headline};
    font-size: ${calc4k(32)};
    font-weight: 500;
    text-transform: uppercase;
    padding-right: ${calc4k(50)};
    padding-top: ${calc4k(20)};

    span {
        font-size: ${calc4k(80)};
        font-weight: 500;
        font-family: ${fonts.headline};
    }
`;
